import type { PolicyConfig, PolicyUiSurfaceConfig } from "@c15t/schema/types"
import type { AllConsentNames } from "c15t"

export const CONSENT_CATEGORIES: AllConsentNames[] = [
  `necessary`,
  `functionality`,
  `measurement`,
  `marketing`
]

const blockingBannerSurface: PolicyUiSurfaceConfig = {
  allowedActions: [`accept`, `customize`],
  primaryActions: [`accept`],
  layout: [[`customize`, `accept`]],
  scrollLock: true
}

const preferenceDialogSurface: PolicyUiSurfaceConfig = {
  allowedActions: [`reject`, `customize`],
  primaryActions: [`customize`],
  layout: [[`reject`, `customize`]],
  scrollLock: true
}

export const buildPolicyPacks = (): PolicyConfig[] => [
  {
    id: `wb_default_opt_in_banner`,
    match: { isDefault: true, fallback: true },
    consent: {
      model: `opt-in`,
      categories: CONSENT_CATEGORIES
    },
    ui: {
      mode: `banner`,
      banner: blockingBannerSurface,
      dialog: preferenceDialogSurface
    }
  }
]
